
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";
import { categoriesFew, ClientTypeFew } from "../data/dummy";
import { googleads, bingads } from "../assets/index";
import ImageCropper from "./ImageCropper";
import defaultImage from "../assets/defaultImage.png";
import { DUMMYRESPONSE } from "./ProjectList";

export const connectionUrl = "https://connect.confidanto.com";
// export const connectionUrl = "http://34.68.229.29/"
ChartJS.register(ArcElement, Tooltip, Legend);

const CreateProject = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [showMicrosoftComingSoon, setShowMicrosoftComingSoon] = useState(false);

  const [projectDetails, setProjectDetails] = useState({
    name: "",
    category: "",
    subCategory: "",
    icon: defaultImage,
    clientType: "",
  });

  // Mapping category to subcategories
  const subCategoryOptions = {
    "Retail & E-commerce": [
      "Fashion & Apparel",
      "Footwear",
      "Electronics",
      "Beauty & Skincare",
      "Furniture & Home Decor",
      "Jewellery",
      "Eyewear",
      "Pet Supplies",
      "Kids’ Products",
      "Grocery & Essentials",
    ],
    "Health & Wellness": [
      "Supplements & Vitamins",
      "Skincare Clinics",
      "Mental Wellness Apps",
      "Fitness Equipment",
      "Weight Loss Programs",
    ],
    "Tech & Software": [
      "SaaS Tools",
      "CRM & Marketing Automation",
      "Cybersecurity Solutions",
      "Web Hosting & Domains",
      "Mobile Apps",
    ],
    "Education & Training": [
      "Online Courses",
      "Test Prep",
      "Study Abroad Consultants",
      "Coding Bootcamps",
      "Language Learning",
    ],
    "Real Estate & Home Services": [
      "Real Estate Portals",
      "Property Developers",
      "Interior Design Services",
      "Pest Control",
      "Home Cleaning Services",
    ],
    Automotive: [
      "Car Dealerships",
      "Car Rentals",
      "Electric Vehicle Brands",
      "Auto Accessories",
      "Insurance Providers",
    ],
    "Finance & Legal": [
      "Digital Banks",
      "Loan Providers",
      "Stock Trading Platforms",
      "Tax & Compliance Services",
      "Legal Services",
    ],
    "Travel & Hospitality": [
      "Flight & Hotel Booking",
      "Visa Consultants",
      "Holiday Packages",
      "Local Experiences",
      "Cruises",
    ],
    "B2B & Industrial": [
      "Logistics & Supply Chain",
      "HR & Payroll Software",
      "Industrial Equipment",
      "Business Loans & Credit",
      "Franchise Opportunities",
    ],
  };

  const categoriesFew = Object.keys(subCategoryOptions);

  const [errorMessage, setErrorMessage] = useState("");
  const [googleAccounts, setGoogleAccounts] = useState([]);
  const [microsoftAccounts, setMicrosoftAccounts] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [selectedMicrosoftCustomerId, setSelectedMicrosoftCustomerId] =
    useState("");
  const [username, setUsername] = useState("");

  const [email, setEmail] = useState("");
  const [bingAdsUrl, setBingAdsUrl] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [connectedGoogleAccount, setConnectedGoogleAccount] = useState(null);
  const [connectedMicrosoftAccount, setConnectedMicrosoftAccount] =
    useState(null);

  useEffect(() => {
    const fetchCurrentProjectStatus = async () => {
      const storedEmail = localStorage.getItem("email");
      const storedProjectId = localStorage.getItem("project_id");

      if (!storedEmail) return;

      try {
        const response = await axios.post(
          "https://api.confidanto.com/projects-data/project-list",
          {
            email: storedEmail,
          }
        );

        if (response.data && storedProjectId) {
          const currentProject = response.data.find(
            (p) => p.project_id == storedProjectId
          );

          if (currentProject && currentProject.ad_accounts) {
            const gAcc = currentProject.ad_accounts.find(
              (acc) => acc.platform === "google_ads"
            );
            const mAcc = currentProject.ad_accounts.find(
              (acc) =>
                acc.platform === "microsoft_ad" ||
                acc.platform === "microsoft_ads"
            );

            if (gAcc) setConnectedGoogleAccount(gAcc);
            if (mAcc) setConnectedMicrosoftAccount(mAcc);
          }
        }
      } catch (error) {
        console.error("Error fetching project list:", error);
      }
    };

    fetchCurrentProjectStatus();
  }, [location]); // Re-run if location changes (e.g., after redirect)

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const response = await axios.post(
          "https://api.confidanto.com/header-data",
          { email: localStorage.getItem("email") }
        );
        if (response.data) {
          setUsername(response.data.username);
          setEmail(response.data.email);
        }
      } catch (error) {
        console.error("Error fetching header data:", error);
      }
    };

    const searchParams = new URLSearchParams(location.search);
    const ids = searchParams.get("customer_ids");
    const currencyTypes = searchParams.get("currencyType");
    const refreshToken = searchParams.get("refresh_token");
    const platform = searchParams.get("platform");
    const accessToken = searchParams.get("access_token");
    const expiresIn = searchParams.get("expires_in");
    const startDates = searchParams.get("start_dates");
    const accountIds = searchParams.get("account_ids");


    if (
      platform === "google_ads" &&
      ids &&
      currencyTypes &&
      refreshToken &&
      startDates
    ) {
      fetchHeaderData();
      alert("Google Ads Account Retrieved. Please select account.");
      setCurrentStep(2);

      const idsArray = ids.split(",");
      const currencyTypesArray = currencyTypes.split(",");
      const startDatesArray = startDates.split(",");

      if (
        idsArray.length === currencyTypesArray.length &&
        idsArray.length === startDatesArray.length
      ) {
        const accounts = idsArray.map((id, index) => ({
          id: id,
          currency: currencyTypesArray[index],
          startDate: startDatesArray[index],
        }));
        setGoogleAccounts(accounts);
      } else {
        console.error(
          "Mismatch between the number of customer IDs, currency types, or start dates."
        );
      }
    } else if (
      platform === "microsoft_ads" &&
      ids &&
      currencyTypes &&
      refreshToken &&
      accessToken &&
      startDates &&
      accountIds
    ) {
      fetchHeaderData();
      alert("Microsoft Ads Account Retrieved. Please select account.");
      setCurrentStep(2);

      const idsArray = ids.split(",");
      const currencyTypesArray = currencyTypes.split(",");
      const startDatesArray = startDates.split(",");
      const accountIdsArray = accountIds.split(",");

      if (accountIdsArray.length === currencyTypesArray.length) {
        const accounts = accountIdsArray.map((accountId, index) => ({
          id: idsArray[index] || idsArray[0],
          refreshToken: refreshToken,
          accessToken: accessToken,
          expiresIn: expiresIn,
          currency: currencyTypesArray[index],
          startDate: startDatesArray[index] || startDatesArray[0],
          account_id: accountId,
        }));

        setMicrosoftAccounts(accounts);
      } else {
        console.error(
          "Mismatch between number of Microsoft Ads account IDs and currency types."
        );
      }
    }

    if (
      location.pathname === "/connect-with-Googleads" ||
      location.state?.step === 2
    ) {
      setCurrentStep(2);
    }
  }, [location]);

  function getUrlParameter(parameterName) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(parameterName);
  }

  const handleSaveCustomerId = async () => {
    try {
      if (!selectedCustomerId) {
        setErrorMessage("Please select a Google Ads account.");
        return;
      }

      const selectedAccount = googleAccounts.find(
        (acc) => acc.id == selectedCustomerId
      );
      if (!selectedAccount) {
        setErrorMessage("Could not find the selected account.");
        return;
      }

      let project_id = JSON.parse(localStorage.getItem("project_id"));
      let email = localStorage.getItem("email");
      let refreshToken = getUrlParameter("refresh_token");
      let platform = getUrlParameter("platform");

      const requestData = {
        project_id: project_id,
        customer_id: Number(selectedCustomerId),
        email: email,
        refresh_token: refreshToken,
        currency_type: selectedAccount.currency,
        platform: platform,
        campaign_start_date: selectedAccount.startDate,
      };

      console.log("Request Data for Google Ads:", requestData);

      const response = await axios.post(
        "https://api.confidanto.com/connect-google-ads/connect-with-google-ads",
        requestData
      );

      if (response.status === 201) {
        console.log("Customer ID saved successfully:", response.data);
        navigate(`/project-details/${project_id}`, { replace: true });
      } else if (response.status == 400) {
        alert("Your account is already connected");
        navigate(`/projects`, { replace: true });
      } else {
        console.log("Unexpected response status:", response);
        setErrorMessage("Unexpected error occurred. Please try again.");
        navigate(`/projects`, { replace: true });
      }
    } catch (error) {
      if (error.response) {
        console.error("Error saving customer ID:", error.response.data);
        setErrorMessage(
          `Error: ${error.response.data.message || "Bad request"}`
        );
      } else if (error.request) {
        console.error("No response received:", error.request);
        setErrorMessage("No response from server. Please check your network.");
      } else {
        console.error("Error setting up request:", error.message);
        setErrorMessage("Error: Failed to save customer ID.");
      }
      navigate(`/projects`, { replace: true });
    }
  };

  const handleSaveMicrosoftCustomerId = async () => {
    try {
      if (!selectedMicrosoftCustomerId) {
        setErrorMessage("Please select a Microsoft Ads account.");
        return;
      }

      const selectedAccount = microsoftAccounts.find(
        (acc) => acc.account_id == selectedMicrosoftCustomerId
      );

      if (!selectedAccount) {
        setErrorMessage("Could not find the selected Microsoft account.");
        return;
      }

      let project_id = JSON.parse(localStorage.getItem("project_id"));
      let email = localStorage.getItem("email");
      let platform = getUrlParameter("platform");

      const requestData = {
        project_id: project_id,
        customer_id: Number(selectedAccount.id),
        email: email,
        refresh_token: selectedAccount.refreshToken,
        access_token: selectedAccount.accessToken,
        expires_in: selectedAccount.expiresIn,
        currency_type: selectedAccount.currency,
        platform: platform,
        campaign_start_date: selectedAccount.startDate,
        account_id: selectedAccount.account_id,
      };

      const response = await axios.post(
        "https://api.confidanto.com/connect-google-ads/connect-with-google-ads",
        requestData
      );

      if (response.status === 201) {
        console.log("Microsoft Customer ID saved successfully:", response.data);
        navigate(`/project-details/${project_id}`, { replace: true });
      } else {
        console.log("Unexpected response status:", response);
        setErrorMessage("Unexpected error occurred. Please try again.");
        navigate(`/projects`, { replace: true });
      }
    } catch (error) {
      if (error.response) {
        console.error("Error saving customer ID:", error.response.data);
        setErrorMessage(
          `Error: ${error.response.data.message || "Bad request"}`
        );
      } else if (error.request) {
        console.error("No response received:", error.request);
        setErrorMessage("No response from server. Please check your network.");
      } else {
        console.error("Error setting up request:", error.message);
        setErrorMessage("Error: Failed to save customer ID.");
      }
      navigate(`/projects`, { replace: true });
    }
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setProjectDetails({
      ...projectDetails,
      category: selectedCategory,
      subCategory: "", // reset subcategory on category change
    });
  };

  const handleCreateProject = async (event) => {
    event.preventDefault();
    const name = event.target.name.value;
    const category = event.target.category.value;
    const clientType = event.target.clientType.value;
    const subCategory = event.target.subCategory.value;

    const updatedProjectDetails = {
      ...projectDetails,
      name,
      category,
      clientType,
      subCategory,
    };
    setProjectDetails(updatedProjectDetails);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("category", category);
    formData.append("sub_category", subCategory);
    formData.append("clientType", clientType);

    if (projectDetails.icon && typeof projectDetails.icon !== "string" && projectDetails.icon !== defaultImage) {
      formData.append("image", projectDetails.icon);
    }

    const email = localStorage.getItem("email");
    if (email) {
      formData.append("email", email);
    }

    try {
      const response = await axios.post(
        "https://api.confidanto.com/projects-data/create-project",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      localStorage.setItem("project_id", response.data.id);

      if (response.status === 200) {
        setCurrentStep(2);
        // setProjectId(response.data.project_id);
        navigate("/connect-with-Googleads");
        showBingAdsUrl();
      } else {
        setErrorMessage("Error creating project. Please try again.");
      }
    } catch (error) {
      console.error("Error saving project:", error);
      setErrorMessage("Error saving project. Please try again.");
    }
  };

  const handleIconUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProjectDetails((prevDetails) => ({
        ...prevDetails,
        icon: file,
      }));
      setIsEditing(true);
    }
  };

  const handleConnectAccount = async (type) => {
    try {
      if (type === "microsoft") {
        window.location.href = `${connectionUrl}/microsoft_ads/authorize`;
      } else {
        // google ads
        window.location.href = `${connectionUrl}/authorize`;
      }
    } catch (error) {
      console.error("Error during authorization:", error);
    }
  };

  const showBingAdsUrl = () => {
    setBingAdsUrl("http://localhost:3000/connect-with-Bingads");
  };

  const StepIndicator = () => (
    <div className="bg-gray-50 border-l border-gray-200 p-8 flex flex-col justify-between hidden md:flex">
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-6">
          Setup Progress
        </h3>
        <ul className="space-y-5">
          {[
            "Create Project",
            "Connect with Google ads",
            "Select Customer Id",
          ].map((step, index) => (
            <li key={index} className="flex items-center gap-3">
              <div
                className={`w-6 h-6 flex items-center justify-center rounded-full ${index < (currentStep === 1 ? 1 : 3)
                  ? "bg-green-500 text-white"
                  : "border border-gray-300 text-gray-400"
                  }`}
              >
                {index < (currentStep === 1 ? 1 : 1) ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4.5 12.75l6 6 9-13.5"
                    />
                  </svg>
                ) : (
                  <span className="text-sm">{index + 1}</span>
                )}
              </div>
              <span
                className={`${index < (currentStep === 1 ? 2 : 3)
                  ? "text-gray-800"
                  : "text-gray-400"
                  } text-sm font-medium`}
              >
                {step}
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="border-t border-gray-200 mt-10 pt-6">
        <p className="text-sm text-gray-500 mb-3">
          Having trouble? We’re here to help you through the process.
        </p>
        <button
          className="w-full bg-white border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 py-2 rounded-lg font-medium transition-all"
          onClick={() => {
            navigate(`/customer-support`);
          }}
        >
          Contact Us
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col items-center w-full h-full bg-gray-100  justify-center relative">
      <main className="w-full flex flex-col lg:flex-row justify-center relative overflow-hidden h-full mb-10">
        {currentStep === 1 ? (
          <div className="flex-1 p-10">
            <h2 className="text-3xl font-semibold text-gray-800 mb-24 text-center">
              Create a Project
            </h2>

            <form
              onSubmit={handleCreateProject}
              className="grid grid-cols-1 md:grid-cols-2 gap-11"
            >
              {/* Project Icon */}
              <div className="flex flex-col items-center">
                <label className="text-sm font-medium text-gray-700 mb-2">
                  Project Icon
                </label>
                <img
                  src={
                    typeof projectDetails.icon === "string"
                      ? projectDetails.icon
                      : URL.createObjectURL(projectDetails.icon)
                  }
                  alt="Project Icon"
                  className="w-auto h-1/3 rounded-full border-4 border-indigo-100 shadow hover:scale-105 transition cursor-pointer"
                  onClick={() =>
                    document.getElementById("icon-upload-input").click()
                  }
                />
                <input
                  id="icon-upload-input"
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={handleIconUpload}
                />
                {isEditing && (
                  <ImageCropper
                    projectDetails={projectDetails}
                    setProjectDetails={setProjectDetails}
                  />
                )}
              </div>

              {/* Project Info */}
              <div className="flex flex-col gap-5">
                <input
                  type="text"
                  name="name"
                  placeholder="Project Name"
                  className="p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  required
                  value={projectDetails.name}
                  onChange={(e) =>
                    setProjectDetails({
                      ...projectDetails,
                      name: e.target.value,
                    })
                  }
                />

                <select
                  name="category"
                  required
                  value={projectDetails.category}
                  onChange={handleCategoryChange}
                  className="p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="">Select Category</option>
                  {categoriesFew.map((cat) => (
                    <option key={cat}>{cat}</option>
                  ))}
                </select>

                <select
                  name="subCategory"
                  required
                  disabled={!projectDetails.category}
                  value={projectDetails.subCategory}
                  onChange={(e) =>
                    setProjectDetails({
                      ...projectDetails,
                      subCategory: e.target.value,
                    })
                  }
                  className={`p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 ${!projectDetails.category
                    ? "bg-gray-100 cursor-not-allowed"
                    : ""
                    }`}
                >
                  <option value="">
                    {projectDetails.category
                      ? "Select Subcategory"
                      : "Select category first"}
                  </option>
                  {projectDetails.category &&
                    subCategoryOptions[projectDetails.category].map((sub) => (
                      <option key={sub}>{sub}</option>
                    ))}
                </select>

                <select
                  name="clientType"
                  required
                  value={projectDetails.clientType}
                  onChange={(e) =>
                    setProjectDetails({
                      ...projectDetails,
                      clientType: e.target.value,
                    })
                  }
                  className="p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="">Select Client Type</option>
                  {ClientTypeFew.map((ct) => (
                    <option key={ct}>{ct}</option>
                  ))}
                </select>

                <button
                  type="submit"
                  className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-md transition"
                >
                  Continue
                </button>

                {errorMessage && (
                  <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
                )}
              </div>
            </form>
          </div>
        ) : (
          currentStep === 2 && (
            <div className="flex flex-col lg:flex-row w-full max-w-6xl bg-white rounded-2xl shadow-lg overflow-hidden mx-auto mt-6 border border-gray-200">
              {/* LEFT PANEL */}
              <div className="flex flex-col w-full overflow-y-auto  px-8 py-10 bg-white no-scrollbar">
                <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                  Connect your ad accounts
                </h2>
                <p className="text-gray-500 mb-8">
                  Stay in sync with Google Ads and Microsoft Ads.
                </p>

                {/* GOOGLE ACCOUNT INFO */}
                <div className="border border-gray-200 rounded-lg p-5 mb-6">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <img
                        src="https://www.svgrepo.com/show/475656/google-color.svg"
                        alt="Google"
                        className="w-6 h-6"
                      />
                      <h3 className="font-medium text-gray-800">
                        Google Account
                      </h3>
                    </div>
                    {email && (
                      <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded-full font-medium">
                        User Connected
                      </span>
                    )}
                  </div>

                  {/* Show user's email */}
                  {email && (
                    <div className="border rounded-md p-3 flex items-center justify-between bg-gray-50 mb-4">
                      <div className="text-gray-700 text-sm">
                        {email ||
                          localStorage.getItem("email") ||
                          "No email found"}
                        <br />
                        <span className="text-xs text-gray-500">Connected</span>
                      </div>
                      <button
                        className="text-red-500 hover:text-red-700 text-sm font-medium"
                        onClick={() => {
                          setEmail("");
                          localStorage.removeItem("email");
                          alert("Disconnected successfully!");
                        }}
                      >
                        Revoke
                      </button>
                    </div>
                  )}
                </div>

                {/* GOOGLE ADS ACCOUNTS LIST */}
                <div className="border border-gray-200 rounded-lg p-5 mb-6">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <img
                        src={googleads}
                        alt="Google Ads"
                        className="w-6 h-6"
                      />
                      <h3 className="font-medium text-gray-800">
                        Google Ads Accounts
                      </h3>
                    </div>
                  </div>

                  {/* SHOW CONNECTED ACCOUNT IF EXISTS */}
                  {connectedGoogleAccount ? (
                    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                      <p className="text-sm font-semibold text-green-800 mb-1">
                        ✓ Account Already Connected
                      </p>
                      <p className="text-sm text-green-700">
                        Customer ID: {connectedGoogleAccount.customer_id}
                      </p>
                      <p className="text-xs text-green-600 mt-1">
                        Currency: {connectedGoogleAccount.currency}
                      </p>
                      {false && <button
                        onClick={() => handleConnectAccount("google")}
                        className="text-xs text-indigo-600 underline mt-2 hover:text-indigo-800"
                      >
                        Switch Account?
                      </button>}
                    </div>
                  ) : null}

                  {googleAccounts.length > 0 ? (
                    <>
                      <p className="text-gray-500 text-sm mb-4">
                        Choose a Google Ads account to connect:
                      </p>
                      <div className="space-y-3">
                        {googleAccounts.map((acc, index) => (
                          <div
                            key={index}
                            className={`flex items-center justify-between border rounded-md p-3 bg-gray-50 hover:bg-gray-100 transition ${selectedCustomerId === acc.id
                              ? "ring-2 ring-indigo-500"
                              : ""
                              }`}
                          >
                            <div>
                              <p className="text-sm font-medium text-gray-700">
                                Google Account
                              </p>
                              <p className="text-xs text-gray-500">
                                Customer ID: {acc.id}
                              </p>
                              <p className="text-xs text-gray-400">
                                Currency: {acc.currency}
                              </p>
                            </div>
                            <button
                              className={`px-4 py-1.5 rounded-md font-medium text-sm ${selectedCustomerId === acc.id
                                ? "bg-green-100 text-green-700 border border-green-400 cursor-not-allowed"
                                : "bg-indigo-600 text-white hover:bg-indigo-700"
                                }`}
                              onClick={() => setSelectedCustomerId(acc.id)}
                              disabled={selectedCustomerId === acc.id}
                            >
                              {selectedCustomerId === acc.id
                                ? "Selected"
                                : "Connect"}
                            </button>
                          </div>
                        ))}
                      </div>

                      <button
                        onClick={handleSaveCustomerId}
                        className="w-full mt-6 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 rounded-md transition"
                      >
                        Save Google Account
                      </button>
                    </>
                  ) : (
                    !connectedGoogleAccount && (
                      <div className="text-center text-gray-500 text-sm">
                        No Google Ads accounts detected. Please connect first.
                        <button
                          onClick={() => handleConnectAccount("google")}
                          className="block mx-auto mt-3 text-blue-600 hover:underline"
                        >
                          Connect Google Ads
                        </button>
                      </div>
                    )
                  )}
                </div>

                {/* MICROSOFT ADS */}
                <div className="border border-gray-200 rounded-lg p-5">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <img
                        src={bingads}
                        alt="Microsoft Ads"
                        className="w-6 h-6"
                      />
                      <h3 className="font-medium text-gray-800">
                        Microsoft Ads
                      </h3>
                    </div>
                  </div>

                  {/* SHOW CONNECTED MICROSOFT ACCOUNT IF EXISTS */}
                  {connectedMicrosoftAccount ? (
                    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                      <p className="text-sm font-semibold text-green-800 mb-1">
                        ✓ Account Already Connected
                      </p>
                      <p className="text-sm text-green-700">
                        Customer ID: {connectedMicrosoftAccount.customer_id}
                      </p>
                      <p className="text-sm text-green-700">
                        Account ID: {connectedMicrosoftAccount.account_id}
                      </p>
                      <p className="text-xs text-green-600 mt-1">
                        Currency: {connectedMicrosoftAccount.currency}
                      </p>
                      {false && <button
                        onClick={() => handleConnectAccount("microsoft")}
                        className="text-xs text-indigo-600 underline mt-2 hover:text-indigo-800"
                      >
                        Switch Account?
                      </button>}
                    </div>
                  ) : null}

                  {microsoftAccounts.length > 0 ? (
                    <>
                      <p className="text-gray-500 text-sm mb-4">
                        Choose a Microsoft Ads account to connect:
                      </p>
                      <div className="space-y-3">
                        {microsoftAccounts.map((acc, index) => (
                          <div
                            key={index}
                            className={`flex items-center justify-between border rounded-md p-3 bg-gray-50 hover:bg-gray-100 transition ${selectedMicrosoftCustomerId === acc.account_id
                              ? "ring-2 ring-indigo-500"
                              : ""
                              }`}
                          >
                            <div>
                              <p className="text-sm font-medium text-gray-700">
                                Microsoft Account
                              </p>
                              <p className="text-xs text-gray-500">
                                Account ID: {acc.account_id}
                              </p>
                              <p className="text-xs text-gray-500">
                                Customer ID: {acc.id}
                              </p>
                              <p className="text-xs text-gray-400">
                                Currency: {acc.currency}
                              </p>
                            </div>
                            <button
                              className={`px-4 py-1.5 rounded-md font-medium text-sm ${selectedMicrosoftCustomerId === acc.account_id
                                ? "bg-green-100 text-green-700 border border-green-400 cursor-not-allowed"
                                : "bg-indigo-600 text-white hover:bg-indigo-700"
                                }`}
                              onClick={() =>
                                setSelectedMicrosoftCustomerId(acc.account_id)
                              }
                              disabled={
                                selectedMicrosoftCustomerId === acc.account_id
                              }
                            >
                              {selectedMicrosoftCustomerId === acc.account_id
                                ? "Selected"
                                : "Connect"}
                            </button>
                          </div>
                        ))}
                      </div>
                      <button
                        onClick={handleSaveMicrosoftCustomerId}
                        className="w-full mt-6 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 rounded-md transition"
                      >
                        Save Microsoft Account
                      </button>
                    </>
                  ) : (
                    !connectedMicrosoftAccount && (
                      <div className="text-center text-gray-500 text-sm">
                        <p className="text-gray-500 text-sm mb-4">
                          Used to manage your Ads in Microsoft.
                        </p>
                        <div
                          className="relative inline-block"
                          onMouseEnter={() => setShowMicrosoftComingSoon(true)}
                          onMouseLeave={() => setShowMicrosoftComingSoon(false)}
                        >
                          <button
                            className="text-blue-600 text-sm font-medium hover:underline"
                            onClick={() => setShowMicrosoftComingSoon((prev) => !prev)}
                          >
                            Connect Microsoft Ads
                          </button>

                          {/* Coming Soon Tooltip */}
                          {showMicrosoftComingSoon && (
                            <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-56 bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg z-50 animate-fade-in">
                              🚧 Microsoft Ads integration is coming soon.
                              <br />
                              Stay tuned!
                              <div className="absolute left-1/2 -translate-x-1/2 -top-1 w-3 h-3 bg-gray-900 rotate-45"></div>
                            </div>
                          )}
                        </div>

                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )
        )}
        <StepIndicator />
      </main>
    </div>
  );
};

export default CreateProject;